import { useState } from "react"
import type { MRT_DensityState } from "material-react-table"

export function useTableDensity(tableKey: string) {
    const storageKey = `table_density_${tableKey}`

    const [density, setDensity] = useState<MRT_DensityState>(() => {
        const saved = localStorage.getItem(storageKey)
        return (saved as MRT_DensityState) ?? "comfortable"
    })

    const handleDensityChange = (updater: MRT_DensityState | ((prev: MRT_DensityState) => MRT_DensityState)) => {
        const next = typeof updater === "function" ? updater(density) : updater
        setDensity(next)
        localStorage.setItem(storageKey, next)
    }

    return { density, onDensityChange: handleDensityChange }
}
